module.exports = __webpack_public_path__ + "media/3_27.d05fbcf2.wav";